import { useState, useCallback } from 'react';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';

export function useDragDrop({ onMoveEntry, canEdit }) {
  const [activeId, setActiveId] = useState(null);

  const handleDragStart = useCallback((event) => {
    if (!canEdit) return;
    setActiveId(event.active.id);
  }, [canEdit]);

  const handleDragEnd = useCallback(
    async (event) => {
      setActiveId(null);
      const { active, over } = event;
      if (!over || !canEdit) return;

      const overId = String(over.id);
      if (!overId.includes('-')) return;

      const [dayStr, timeStr] = overId.split('-');
      const newDay = parseInt(dayStr, 10);
      const newTime = timeStr;

      if (active.id !== overId) {
        try {
          await onMoveEntry(active.id, newDay, newTime);
        } catch (err) {
          console.error('Move failed:', err);
        }
      }
    },
    [canEdit, onMoveEntry]
  );

  const handleDragCancel = useCallback(() => {
    setActiveId(null);
  }, []);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor)
  );

  const dndContextProps = {
    sensors,
    collisionDetection: closestCenter,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    onDragCancel: handleDragCancel,
  };

  return { DndContext, dndContextProps, activeId };
}
